//外部引用示例import {isEmpty} from '@/utils/subUtils/BaseCyUtil'
/**
 * 截取字符串
 * @param {string} str 需要截取的字符串
 * @param {number} start 开始的位置
 * @param {number} end 结束的位置
 * @returns {string}
 */
export const substring = (str, start, end) => {
    return str.substring(start, end)
}
// import { json2excel } from "@/utils/setMethods.js";

//过滤文件扩展名关键字和大小M
// 示例图片 ['JPG', 'PNG', 'GIF', 'jpeg'], '10', ['JPG', 'PNG', 'GIF']
//示例音频['MP3','wav','audio/mpeg'],'100',['MP3','wav']
// 示例视频['MP4','video/quicktime'],'300',['MP4']
// 示例excel['excel','officedocument.spreadsheetml.sheet'],'100',['excle']
export const beforeAvatarInput = (file, _this, typeS, size, laberS, isTost) => {
    console.log(file.raw.type);
    let isRelType = false;
    for (let k of typeS) {
        //不区分大小写比对两个字符串1是否在2内
        if (compareType(k, file.raw.type)) {
            isRelType = true;
            break;
        }
    }
    let isLt2M = true;
    if (size != undefined) {
        isLt2M = file.size < size * 1024 * 1024;
    }
    if (!isRelType && !isLt2M) {
        if (isTost == false) {
        } else {
            _this.$message.error('上传文件只能是' + laberS + '格式;  并且' + '上传文件大小不能超过' + size + 'MB!');
        }
    } else {
        if (!isRelType) {
            if (isTost == false) {
            } else {
                _this.$message.error('上传文件只能是' + laberS + '格式!');
            }
        }
        if (!isLt2M) {
            if (isTost == false) {
            } else {
                _this.$message.error('上传文件大小不能超过' + size + 'MB!');
            }
        }
    }
    return isRelType && isLt2M;
}

////不区分大小写比对两个字符串1是否在2内 存在返回true
export const compareType = (str1, str2) => {
    //先转成小写然后再看是否包含
    return str2.toLowerCase().indexOf(str1.toLowerCase()) != -1;
}

//转换时分秒传入秒然后转换00:00'00'' 补齐格式化
export const formatSeconds = (value) => {
    let result = parseInt(value)
    let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
    let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

    let res = '';
    res += (h !== '00') ? `${h}:` : '00:';
    res += (m !== '00') ? `${m}'` : "00'";
    res += `${s}''`;
    return res;
}

//转换时分秒传入秒然后转换 00:00'00'' 不补齐格式化
export const formatSeconds1 = (value) => {
    let result = parseInt(value)
    let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
    let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

    let res = '';
    if (h !== '00') res += `${h}:`;
    if (m !== '00') res += `${m}'`;
    res += `${s}''`;
    return res;
}

/*//下载图片组件(没引用 file-saver所以先屏蔽)
import FileSaver from 'file-saver'
import JSZip from 'jszip'
//工具
//各种删除提示的弹窗
//删除提示弹窗 //默认弹窗样式有确定和取消按钮
export const openMsgBox = (_this, title, str1, str2, callback) => {

  const h = _this.$createElement;
  _this.$msgbox({
    title: title,
    message: h('p', null, [
      h('i', {
        class: 'el-icon-warning-outline',
        style: 'color:#ff0000 ;margin-right:15px;font-size: 20px'
      }),
      h('span', {
        style: 'word-break: break-all;',
      }, str1),
      h('p'),
      h('span', {
        style: 'color: #999999;font-size: 8px;word-break: break-all;',
      }, str2)
    ]),
    showCancelButton: true,
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    beforeClose: (action, instance, done) => {
      if (action === 'confirm') {
        if (callback) {
          callback();
        }
        done();
      } else {
        done();
      }
    }
  }).then(action => {
    // _this.$message({
    // 	type: 'warning',
    // 	message: 'action: ' + action
    // });
  });
}*/

//弹窗样式有确定按钮,有icon，取消按钮传文案可以显示，不传不显示。
export const openMsgBox1 = (_this, title, iconSuccess, str1, str2, okStr, cleanStr, callback) => {

    const h = _this.$createElement;
    const icon1 = {
        class: 'el-icon-circle-check',
        style: 'color:#00aa00 ;margin-right:15px;font-size: 20px'
    };

    const icon2 = {
        class: 'el-icon-warning-outline',
        style: 'color:#ff0000 ;margin-right:15px;font-size: 20px'
    };

    _this.$msgbox({
        title: title,
        message: h('p', null, [
            h('i', (iconSuccess ? icon1 : icon2)
                //     {
                //     class: 'el-icon-warning-outline',
                //     style: 'color:#ff0000 ;margin-right:15px;font-size: 20px'
                // }
            ),
            h('span', {
                style: 'word-break: break-all;',
            }, str1),
            h('p'),
            h('span', {
                style: 'color: #999999;font-size: 8px;word-break: break-all;',
            }, str2)
        ]),
        showCancelButton: cleanStr ? true : false,
        confirmButtonText: okStr,
        cancelButtonText: cleanStr,
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                if (callback) {
                    callback('confirm');
                }
                done();
            } else {
                if (callback) {
                    callback('');
                }
                done();
            }
        }
    }).then(action => {
        // _this.$message({
        // 	type: 'warning',
        // 	message: 'action: ' + action
        // });
    });
}

//提示弹窗  //有确定和取消按钮(不传文案没有)（主标题带图标）
export const openMsgBox2 = (_this, title, iconSuccess, str1, str2, okStr, cleanStr, callback) => {

    const h = _this.$createElement;
    const icon1 = {
        class: 'el-icon-circle-check',
        style: 'color:#00aa00 ;margin-right:15px;font-size: 20px'
    };

    const icon2 = {
        class: 'el-icon-warning-outline',
        style: 'color:#ff0000 ;margin-right:15px;font-size: 20px'
    };
    _this.$msgbox({
        title: title,
        message: h('p', null, [
            h('i', (iconSuccess ? icon1 : icon2)),
            h('span', {
                style: 'word-break: break-all;font-size: 20px',
            }, str1),
            h('p'),
            // h('i', {
            //     class: 'el-icon-warning-outline',
            //     style: 'color:#ff0000 ;margin-right:15px;font-size: 20px'
            // }),
            h('div', {style: 'margin-top:20px',}, ""),
            h('span', {
                style: 'word-break: break-all;margin-left:25px;',
            }, str2)
        ]),
        showCancelButton: cleanStr ? true : false,
        confirmButtonText: okStr,
        cancelButtonText: cleanStr,
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                if (callback) {
                    callback('confirm');
                }
                done();
            } else {
                if (callback) {
                    callback();
                }
                done();
            }
        }
    }).then(action => {
        // _this.$message({
        // 	type: 'warning',
        // 	message: 'action: ' + action
        // });
    });
}
//提示弹窗 （带输入框）//有确定和取消按钮(不传文案没有)（主标题带图标）
export const openMsgBox3 = (_this, title, iconSuccess, str1, str2, okStr, cleanStr, callback) => {

    const h = _this.$createElement;
    const icon1 = {
        class: 'el-icon-circle-check',
        style: 'color:#00aa00 ;margin-right:15px;font-size: 20px'
    };

    const icon2 = {
        class: 'el-icon-warning-outline',
        style: 'color:#ff0000 ;margin-right:15px;font-size: 20px'
    };
    _this.$msgbox({
        title: title,
        message: h('p', null, [
            h('i', (iconSuccess ? icon1 : icon2)),
            h('span', {
                style: 'word-break: break-all;font-size: 20px',
            }, str1),
            h('p'),
            // h('i', {
            //     class: 'el-icon-warning-outline',
            //     style: 'color:#ff0000 ;margin-right:15px;font-size: 20px'
            // }),
            h('div', {style: 'margin-top:20px',}, ""),
            h('span', {
                style: 'word-break: break-all;margin-left:25px;',
            }, str2)
        ]),
        showCancelButton: cleanStr ? true : false,
        confirmButtonText: okStr,
        cancelButtonText: cleanStr,
        beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
                if (callback) {
                    callback('confirm');
                }
                done();
            } else {
                if (callback) {
                    callback();
                }
                done();
            }
        }
    }).then(action => {
        // _this.$message({
        // 	type: 'warning',
        // 	message: 'action: ' + action
        // });
    });
}
/*// 仿照a标签下载源文件
解决了download因为跨域失效问题
调用示例：
handleDownload(this, fileUlr);
**/
export const handleDownload = (_this, fileUlr) => {
    if (isEmpty(fileUlr)) {
        _this.$message({
            message: '没有源文件',
            type: 'warning'
        })
    } else {
        var downName = "fileName";
        let urlSplit = fileUlr.split("/");
        if (urlSplit && urlSplit.length > 0) {
            downName = urlSplit[urlSplit.length - 1];
        }
        /*
             // 创建a标签
             let link = document.createElement('a');
             // href链接
             link.setAttribute('href', contract_file_url);
             link.setAttribute('download', downName);
             link.setAttribute('target', "_blank");

             // 自执行点击事件
             link.click();*/
        var x = new XMLHttpRequest();
        x.open("GET", fileUlr, true);
        x.responseType = 'blob';
        x.onload = function () {
            //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
            var url = window.URL.createObjectURL(x.response)
            var a = document.createElement('a');
            a.href = url
            a.download = downName;
            a.click()
        }
        x.send();
    }


}


//下载单个文件
export const downloadFileOld = (_this, pictureUrl, saveName, callLoading, onDownloadProgressCallback) => {

    callLoading(true);
    // const promise = downloadBlob(_this, pictureUrl).then(data => { // 下载文件, 并存成Buffer对象
    //     console.log(data);
    //     FileSaver.saveAs(data, saveName) // 利用file-saver保存文件
    //     callLoading(false);
    // });
    var xhr = new XMLHttpRequest();
    xhr.open('GET', pictureUrl);
    xhr.responseType = 'blob';

    xhr.onload = function () {
        // saveAs(xhr.response, saveName, opts);
        FileSaver.saveAs(xhr.response, saveName); // 利用file-saver保存文件
        callLoading(false);
    };
    xhr.onerror = function () {
        console.error('could not download file');
        callLoading(false);
        _this.$message.error('下载失败！');
    };
    xhr.onprogress = function (progress) {

        if (progress.lengthComputable) {
            // console.log(parseInt(event.loaded / event.total * 100) + "%");
            // var loaded = parseInt(event.loaded / event.total * 100) + "%";
            // $('#pros').width(loaded);
            // $('#pros').text(loaded);
            if (onDownloadProgressCallback) {
                onDownloadProgressCallback((100 * progress.loaded / progress.total).toFixed(2) + '%');
            }
        }
    }
    xhr.send();

}


//批量下载文件1.1保存文件名为指定文件名(重名？处理？)BaseCyUtil.allLoadFiles2(this, [[item[1].pictureUrl,item[1].pictureName]]);
export const allLoadFiles2 = (_this, items, zipName, callLoading, onDownloadProgressCallback) => {

    callLoading(true);
    // const items = [['各类地址1','name1'], ['各类地址2','name2']] // 需要下载打包的路径, 可以是本地相对路径, 也可以是跨域的全路径
    //重名处理。
    for (let k of items) {
        for (let j of items) {
            if (k[0] != j[0] && k[1] == j[1]) {
                j[1] = Math.floor(Math.random() * 10) + j[1];
            }
        }
    }
    var items = items;
    const zip = new JSZip()
    const cache = {}
    const promises = []
    var totalBuf = 0;//缓存总大小
    var loadedBuf = 0;//缓存当前总进度
    var bufloadeds = {};//保存进度集合
    var bufCallback = function (progress, url) {//计算总进度
        // onDownloadProgressCallback((100 * progress.loaded / progress.total).toFixed(2) + '%');
        if (onDownloadProgressCallback) {
            bufloadeds[url] = progress.loaded / progress.total;
            let buf = 0;
            for (var k in bufloadeds) {
                buf += bufloadeds[k];
            }
            let bufLeng = (Object.keys(bufloadeds).length);
            if (bufLeng > 0) {
                onDownloadProgressCallback((buf * 100 / bufLeng).toFixed(2) + '%');
            }

        }
    }
    items.forEach(item => {
        const promise = getFile(_this, item[0], bufCallback).then(data => { // 下载文件, 并存成ArrayBuffer对象
            // const arr_name = item.split("/")
            // const file_name = arr_name[arr_name.length - 1] // 获取文件名
            const file_name = item[1];
            zip.file(file_name, data, {
                binary: true
            }) // 逐个添加文件
            cache[file_name] = data
        })
        promises.push(promise)
    })

    Promise.all(promises).then(() => {
        zip.generateAsync({
            type: "blob"
        }).then(content => { // 生成二进制流
            FileSaver.saveAs(content, zipName + ".zip") // 利用file-saver保存文件
            callLoading(false);
        })
    })
}

export const getFile = (_this, url, bufCallback) => {

    return new Promise((resolve, reject) => {
        _this.$axios({
            method: 'get',
            url,
            responseType: 'arraybuffer',

            onDownloadProgress(progress) {

                // console.log(progress.loaded / progress.total * 100,onDownloadProgressCallback);
                // if (onDownloadProgressCallback) {
                if (progress.lengthComputable) {
                    // onDownloadProgressCallback((100 * progress.loaded / progress.total).toFixed(2) + '%');
                    bufCallback(progress, url);
                }
                // }
            }

        }).then(data => {
            resolve(data.data)
        }).catch(error => {
            reject(error.toString())
        })
    })
}


//定时器----- timeout 单位毫秒
export const setMyTimeOut = (callback, timeout) => {
    setTimeout(callback, timeout);
    //调用方法，关闭指定的定时器 或页面关闭
    // clearInterval(timer);//不要this
}
//每隔一段时间循环执行一次，直到调用clearInterval(timer);或页面关闭
export const setMyInterval = (callback, timeout) => {
    return setInterval(callback, timeout);
    //调用方法，关闭指定的定时器
    // clearInterval(timer);//不要this
    //调用方法
    /*  //调用方法，关闭指定的定时器
      // 将定时器名字赋值本地到变量中方便清除
      clearInterval(sessionStorage.getItem("mself.timerVal"));
      this.mself.timerVal = setInterval(buffunction, 1000);
      sessionStorage.setItem("mself.timerVal", this.mself.timerVal);*/
}

//获得音频或者视频的实际长度 传入音频或视频文件
// if (file.duration == undefined) { //外部调用时注意，减少循环次数有值得不用重复计算
export const getMediaLong = (file, onload) => {
    console.log("getMediaLong");

    // var url  = getPictureUrl(file); //创建Image的对象的url
    let audioElement = new Audio(); //手动创建一个Image对象
    audioElement.src = getPictureUrl(file); //创建Image的对象的url


    audioElement.addEventListener("loadedmetadata", function (_event) {
        // console.log(this);
        let duration = this.duration;
        console.log(duration / 60);
        // console.log('height:' + this.height + '----width:' + this.width);
        // file.duration = (duration / 60).toFixed(2);
        // file.pictureHeight = (duration/60).toFixed(2);
        file.duration = formatSeconds(duration);
        onload();
    });
}

//获得图片的实际宽高1
export const getPictureWh2 = (file, onload) => {

    let img = new Image(); //手动创建一个Image对象
    img.src = getPictureUrl(file); //创建Image的对象的url

    img.onload = function () {
        console.log('height:' + this.height + '----width:' + this.width);
        file.pictureWidth = this.width;
        file.pictureHeight = this.height;
        onload();
    }
}

//获得图片的实际宽高2
export const getPictureWh1 = (url, obj, onload) => {
    let img = new Image(); //手动创建一个Image对象
    img.src = url; //创建Image的对象的url
    img.onload = function () {
        console.log('height:' + this.height + '----width:' + this.width);
        obj.pictureWidth = this.width;
        obj.pictureHeight = this.height;
        onload();
    }
}

//获得file 的url 。耗费资源注意外部调用后就保存不要再频繁调用了
export const getPictureUrl = (file) => {
    let url = window.URL || window.webkitURL;
    return url.createObjectURL(file.raw);
}

//获取列表中所有文件的小用那个mb返回
export const getDiskSizeByList = (fileList) => {
    // console.log(fileList);
    var result = 0;
    for (var item of fileList) {
        result += (item.size / 1024 / 1024);
    }
    return fomatFloat(result, 2);
}

//判断文字长度str文案,longS长度,laber文案关键字,showEmpty是否可为空
export const testingText = (_this, str, longS, laber, showEmpty) => {
    if (showEmpty) {
        if (str == undefined || (str + '').trim().length == 0) {
            _this.$message({
                showClose: true,
                message: '请检查"' + laber + '",不能为空',
                type: 'warning'
            });
            return false;
        }
    }
    if (str != undefined && str.length > longS) {
        _this.$message({
            showClose: true,
            message: '请检查"' + laber + '",最长为' + longS + '个字',
            type: 'warning'
        });
        return false;
    }
    return true;


}


// num为传入的值，n为保留的小数位
export const fomatFloat = (num, n) => {
    var f = parseFloat(num);
    if (isNaN(f)) {
        return false;
    }
    f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n); // n 幂
    var s = f.toString();
    var rs = s.indexOf('.');
    //判定如果是整数，增加小数点再补0
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + n) {
        s += '0';
    }
    return s;
}

// 将日期时间转换为指定格式，如：YYYY-mm-dd HH:MM:SS表示2019-06-06 19:45:00
// let date = new Date()//new Date(str<long>)
// dateFormat("YYYY-mm-dd HH:MM:SS", date)
export const dateFormat = (fmt, date) => {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }

    }

    return fmt;
}

//字符串日期转时间戳long  "YYYY-mm-dd HH:MM:SS"（必须是这个格式，可以是YYYY-mm-dd）
//dateValue 可以不传
export const stringForamtDate = (dateValue) => {
    // var stringTime = "2014-07-10 10:21:12";

//         timestamp2 = timestamp2 / 1000;
// //2014-07-10 10:21:12的时间戳为：1404958872
//         console.log(stringTime + "的时间戳为：" + timestamp2);
    if (dateValue) {
        return Date.parse(new Date(dateValue));
    } else {
        return Date.parse(new Date());
    }

}


//日期打天数加减，index 天数加减，当前日期的字符串值， 当前日期的format规则。返回同foramt规则的结果日期 YYYY-mm-dd HH:MM:SS
//BaseCyUtil.dateAdd(1,bufTime,'YYYY-mm-dd HH:MM:SS');这个调用例子是时间加一天
export const dateAdd = (index, dateValue, fmt) => {
    var longTime = stringForamtDate(dateValue);
    longTime = longTime + 3600 * 24 * index * 1000;
    console.log('longTime =' + longTime);
    return dateFormat(fmt, new Date(longTime));
}

//(倒计时器)用当前时间减去目标时间
//返回： "00:00:00''"(时分秒，如果是负数或0，返回默认字符串defStr。)
//参数说明：
//index天数加减，用于对目标时间的加减整天的修改
//dateValue，目标时间。（目标时间为字符串时间）目标时间格式必须为（如'YYYY-mm-dd HH:MM:SS'）；
//dateKnow当前时间。（传入时间long 13位时间戳）
//defStr（返回值如果是负数或0，返回默认字符串defStr。）
//示例：BaseCyUtil.timeCountdown(1,dateValue,new Date(),"已超时");这个调用例子是目标时间加一天
export const timeCountdown = (index, dateValue, dateKnow, defStr) => {
    var longTime = stringForamtDate(dateValue);
    longTime = longTime + 3600 * 24 * index * 1000;
    // console.log('longTime =' + longTime);
    var longbuf = longTime - dateKnow;
    if (longbuf > 0) {
        return formatSeconds(longbuf / 1000);
    } else {
        return defStr
    }


}


//判断两个区间数据间是否有交集
export const isDateIntersection = (startdate1, enddate1, startdate2, enddate2) => {
    if (startdate1 >= startdate2 && startdate1 <= enddate2) {
        return true;
    }
    if (enddate1 >= startdate2 && enddate1 <= enddate2) {
        return true;
    }
    if (startdate1 <= startdate2 && enddate1 >= enddate2) {
        return true;
    }
    return false;
}

//判断两个区间数据间是否有交集(特殊处理，1开始时间可以与2结束时间重叠，1结束时间可以与2开始时间重叠)
export const isDateIntersection1 = (startdate1, enddate1, startdate2, enddate2) => {
    if (startdate1 >= startdate2 && startdate1 < enddate2) {
        return true;
    }
    if (enddate1 > startdate2 && enddate1 <= enddate2) {
        return true;
    }
    if (startdate1 <= startdate2 && enddate1 >= enddate2) {
        return true;
    }
    return false;
}
//返回今天时间0点-今天结束时间；ifKonw==true时代表结束时间为 现在，ifKonw==false时代表结束时间为今天23.59.59
// this.valueTime= todayZero(false)  ;//获得今天时间
export const todayZero = (ifKonw) => {
    let date = new Date()//new Date(str<long>)
    let start = dateFormat("YYYY-mm-dd", date);
    let end=start;
    //js 取得今天0点：
     start = start + " 00:00:00";
    if (ifKonw) {
        end = dateFormat("YYYY-mm-dd HH:MM:SS", new Date());
    } else {
        end = end + " 23:59:59";
    }



    return [start, end];
}
//从今天开始算最近多少天
// dataNo=365 为最近365天
export const today365 = (ifKonw, dataNo) => {
    let date = new Date()//new Date(str<long>)
    let end= dateFormat("YYYY-mm-dd", date);
    if (ifKonw) {
        end = dateFormat("YYYY-mm-dd HH:MM:SS", new Date());
    } else {
        end =end  + " 23:59:59";
    }
    date.setTime(date.getTime() - 3600 * 1000 * 24 * dataNo);
    //js 取得历史天0点：
    let start = dateFormat("YYYY-mm-dd", date)+ " 00:00:00";

    return [start, end];
}


// //导出excel
// function my_json2excel(fileName,sheetName,tHeader,filterVal,data){
//     // var _this = _this;
//
//     //注意：组装的导出excel所需要的数据结构
//     // var excelDatas = [
//     //     {
//     //         tHeader: [
//     //             "发布时间",
//     //             "作者",
//     //             "内文标题",
//     //             "实际点击量",
//     //             "点击量(PV)",
//     //             "点击量(UV)",
//     //             "稿件类别",
//     //             "采访情况",
//     //             "文章类型",
//     //             "稿件数",
//     //             "总稿件数",
//     //             "稿费金额（元）",
//     //         ], // sheet表一头部
//     //         filterVal: [
//     //             "articleReleaseTime",
//     //             "articleAuthor",
//     //             "articleTitle",
//     //             "articleClick",
//     //             "articleClickCount",
//     //             "articleVisitCount",
//     //         ], // 表一的数据字段
//     //         tableDatas: res.data, // 表一的整体json数据
//     //         sheetName: "稿件库", // 表一的sheet名字
//     //     },
//     // ];
//     var excelDatas = [
//         {
//             tHeader: tHeader, // sheet表一头部
//             filterVal: filterVal, // 表一的数据字段
//             tableDatas: data, // 表一的整体json数据
//             sheetName: sheetName, // 表一的sheet名字
//         },
//     ];
//     //   引入的函数
//     json2excel(excelDatas, fileName, true, "xlsx");
// }
/**
 * Tree型结构通过叶子id 查找匹配的完整路径
 * id:     匹配的值
 * data: 匹配的数组数据
 * prop: 匹配的字段名
 * child:配置子项字段名
 * 数据结构
 *  options: [{
 *         value: 'zhinan',
 *         label: '指南',
 *          children: [{
 *          value: 'shejiyuanze',
 *          label: '设计原则',
 *          children:
 *   console.log("getFathersById=", _this.getFathersById(53, _this.productCateOptions, 'value','children')) // [1,2]
 */
export const getFathersById = (id, data, prop, child) => {
    var arrRes = []
    const rev = (data, nodeId) => {
        for (var i = 0, length = data.length; i < length; i++) {
            const node = data[i]
            if (node[prop] === nodeId) {
                arrRes.unshift(node[prop])
                return true
            } else {
                if (node[child] && node[child].length) {
                    if (rev(node[child], nodeId)) {
                        arrRes.unshift(node[prop])
                        return true
                    }
                }
            }
        }
        return false
    }
    rev(data, id)
    return arrRes
}

// 穷举  二维数组中，字数组中对象之间穷举，使用字数组中是 对象或 string的
// ，实现多属性组合(全部可能性组合成一个列表返回)
// 调用上面的组合方法  arr是组合之前的数组例如[[{key: "包装", value: "1"},{key: "包装", value: "2"}],[{key: "纸质", value: "3"},{key: "纸质", value: "4"}],[{key: "语言", value: ""},{key: "语言", value: ""}]]
//defItme(可选参数) 为一个 值为空的 对象 或字符串，结构根据其他列表一样 如{key: "", value: ""}
export const getCombination = (array, defItme) => {
    let resultArr = [];
    array.forEach((arrItem) => {

        if (resultArr.length === 0) {
            let firstItem = [];
            if (arrItem && arrItem.length == 0) {
                firstItem.push([defItme ? defItme : {}])
            } else {
                arrItem.forEach(item => {
                    firstItem.push([item]);
                })
            }
            resultArr = firstItem
        } else {
            const emptyArray = [];
            resultArr.forEach((item) => {
                if (arrItem && arrItem.length == 0) {
                    emptyArray.push([...item, defItme ? defItme : {}])
                } else {
                    arrItem.forEach((value) => {
                        emptyArray.push([...item, value])
                    })
                }
            })
            resultArr = emptyArray
        }
    });
    return resultArr;

}

//二维数组去重
// let arr = [[{a:1},{a:1,b:2}],[{a:1}],[{a:1},{a:1,b:2}]]
export const getUnique = (array) => {
    let obj = {}
    return array.filter((item) => {
        // 防止key重复
        let newItem = item + JSON.stringify(item)
        return obj.hasOwnProperty(newItem) ? false : obj[newItem] = true
    })
}

// js一维数组去重，返回重复项，同时返回去重结果
// [1, 2, 3, 4, 5, 5 , 6, 7, 8, 2, 3]; 返回[1.2.3.4.5.6.7.8]和result=[2,3,5]
export const getUniqueList = (array) => {
    let result = [[], []];
    for (let i = 0; i < array.length; i++) {
        if (result[0].indexOf(array[i]) === -1) {
            result[0].push(array[i]);
        } else {
            result[1].push(array[i]);
        }
    }
    return result;
}

// 16isEmpty方法封装
/**
 isEmpty("")
 //true
 isEmpty([])
 //true
 isEmpty({})
 //true
 isEmpty(0)
 //flase 20220114修改 (old为//true）
 isEmpty(undefined)
 //true
 isEmpty(null)
 //true
 isEmpty(1)
 //false
 */
export const isEmpty = (val) => {
    // null or undefined
    if (val == null) return true;
    if (typeof val === 'boolean') return false;
    if (typeof val === 'number') return !val && val !== 0;//def if (typeof val === 'number') return !val   20220114修改
    if (val instanceof Error) return val.message === '';
    switch (Object.prototype.toString.call(val)) {
        // String or Array
        case '[object String]':
        case '[object Array]':
            return !val.length;

        // Map or Set or File
        case '[object File]':
        case '[object Map]':
        case '[object Set]': {
            return !val.size;
        }
        // Plain Object
        case '[object Object]': {
            return !Object.keys(val).length;
        }
    }

    return false;
}


// 验证社会信用代码 creditCodeReg
// 验证社会信用代码  可以输入 0 或无
export const validateCreditCodeCan0 = (value1) => {

    if (value1 == '无' || value1 == '0') {
        return true;
    } else {
        return validateCreditCode(value1);
    }
}

// 验证社会信用代码 creditCodeReg
export const validateCreditCode = (value1) => {
    const creditCodeReg = /^[0-9a-zA-Z]+$/;
    if (value1.length == 15 || value1.length == 17 || value1.length == 18 || value1.length == 20) {
        if (creditCodeReg.test(value1)) {
            return true;
        } else {
            return false;
        }
    } else {
        // callback('请输入统一社会信用码')
        return false;
    }
}


